import React from 'react'
import { Cube } from '../../../geometries/Cube'

export const DoorPlane = ({ isLeft }) => {
	const rotation = isLeft ? Math.PI - 0.5 : 0.5
	const position = isLeft ? -1.5 : 1.5

	return (
		<group position={[-6, 0, position]} scale={[1, 1, 1]} rotation={[0, rotation, 0]} castShadow receiveShadow>
			<Cube color='gray' position={[0, 23.75, 0]} size={[1, 47.5, 25]} opacity={0.7} />
			<Cube color='#000' position={[0, 25, -10]} size={[6, 1, 1]} />
			<Cube color='#000' position={[2.5, 25, -8]} size={[1, 1, 4]} />
			<Cube color='#000' position={[-2.5, 25, -8]} size={[1, 1, 4]} />
		</group>
	)
}
